import React from 'react';
import Logo from '../assets/sawari-logo.png';

import FBLogo from '../assets/fb.png';
import InstaLogo from '../assets/insta.png';
import LinkedInLogo from '../assets/linkendin.png';

import { Link } from 'react-router-dom'

function Footerbar({ bgColorClass = 'bg-white' }) {
    return (
        <div
            className={`footer lg:px-[12%] px-[6%] relative ${bgColorClass} border-solid border-t border-inverted-light pt-24`}
        >
            <div
                className="glow-effect-metric"
                style={{
                    bottom: '0px',
                    left: '0px',
                }}
            ></div>
            <div className="mb-7">
                <img src={Logo} className="object-cover min-w-[280px] h-[118px]" />
                {/* <Logo type="white" /> */}
            </div>
            <div className="grid grid-cols-2 gap-x-6 gap-y-4 lg:flex lg:flex-row justify-between mb-7 border-solid border-b border-inverted-light pb-10">
                <div className='lg:w-[300px]'>
                    <div className="label-medium content-primary my-4">
                        Get in Touch
                    </div>
                    <div className="body-medium content-tertiary my-2">
                        Sawari Pakistan Limited
                        R1, 179 Bordesley Green East, Birmingham,
                        West Midlands, England, B9 5SR.
                        United Kingdom
                    </div>
                    <br />
                    {/* <div className="body-medium content-tertiary my-2">
                        Sawari Airport Transfers (SMC-Private) Limited
                        Office No. 3, Rehmat House, Sandal Road,
                        Ward No. 14, Gujarkhan, Rawalpindi,
                        Pakistan
                    </div> */}
                </div>
                <div>
                    <div className="label-medium content-primary my-4">
                        24/7 Support
                    </div>
                    <div className="body-medium content-tertiary my-2">

                        0092 335 4400044

                    </div>
                    <div className="body-medium content-tertiary my-2">
                        hello@sawaripakistan.com
                    </div>
                    <div className="body-medium content-tertiary mt-16 !font-bold">
                        <Link to="/sign-in" className="!text-inherit !hover:text-inherit !visited:text-inherit !active:text-inherit">
                            Dashboard
                        </Link>
                    </div>
                </div>
                <div>
                    <div className="label-medium content-primary my-4">Account</div>
                    <div className="body-medium content-tertiary my-2">
                        <Link to="/about-us" className="!text-inherit !hover:text-inherit !visited:text-inherit !active:text-inherit">
                            About Us
                        </Link>
                    </div>
                    <div className="body-medium content-tertiary my-2">
                        <Link to="/privacy-policy" className="!text-inherit !hover:text-inherit !visited:text-inherit !active:text-inherit">
                            Privacy Policy
                        </Link>
                    </div>
                    <div className="body-medium content-tertiary my-2">
                        <Link to="/terms-and-conditions" className="!text-inherit !hover:text-inherit !visited:text-inherit !active:text-inherit">
                            Terms And Condition
                        </Link>
                    </div>
                    <div className="body-medium content-tertiary my-2">
                        <Link to="/contact-us" className="!text-inherit !hover:text-inherit !visited:text-inherit !active:text-inherit">
                            Contact Us
                        </Link>
                    </div>
                    <div className="body-medium content-tertiary my-2">
                        <Link to="/gdpr-policy" className="!text-inherit !hover:text-inherit !visited:text-inherit !active:text-inherit">
                            GDPR Policy
                        </Link>
                    </div>
                </div>
                <div>
                    <div className="label-medium content-primary my-4">Services</div>
                    <div className="body-medium content-tertiary my-2">
                        <Link to="/airport-transfers">
                            Airport Transfers
                        </Link>
                    </div>
                    <div className="body-medium content-tertiary my-2">
                        <Link to="/vehicle-rentals">
                            Vehicle Rentals
                        </Link>
                    </div>
                    <div className="body-medium content-tertiary my-2">
                        <Link to="/tourism-packages">
                            Tourism Packages
                        </Link>
                    </div>
                </div>
            </div>
            <div className="flex flex-row justify-between my-10">
                <div className="body-large content-inverted-secondary">
                    © {new Date().getFullYear() || '2025'} Sawari Pakistan. All rights reserved.
                </div>
                <div className="flex flex-row justify-between items-center">

                    <img src={FBLogo} alt="Fb logo" />

                    <img src={InstaLogo} alt="Insta logo" className="ml-3" />

                    <img src={LinkedInLogo} alt="Linkedin logo" className="ml-3" />

                </div>
            </div>
        </div>
    );
}

export default Footerbar;
